package net.sergeych.synctools

/**
 * JS is single-threaded, so we don't need any additional protection:
 */
actual fun ProtectedOp(): ProtectedOpImplementation = object : ProtectedOpImplementation {
    override fun lock() {}
    override fun unlock() {}
}